module.exports = __webpack_public_path__ + "img/No Requested Docs.dd8121e1.svg";